import SupportV2OrdersListPage from 'pages/support-v2/support-v2-orders-list-page';

// TODO - I can't get this one to trigger in the CA prestream off support links in prod - it might be able to be removed
export default function SupportOrdersDetailPage() {
  return <SupportV2OrdersListPage />;
}
